webpackJsonp([57461569616539],{

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(46);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(59);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(58);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(115);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(212);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),

/***/ 133:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(133);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	var castSlice = __webpack_require__(134),
	    hasUnicode = __webpack_require__(72),
	    stringToArray = __webpack_require__(137),
	    toString = __webpack_require__(29);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(68),
	    deburr = __webpack_require__(75),
	    words = __webpack_require__(77);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(70);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(132),
	    hasUnicode = __webpack_require__(72),
	    unicodeToArray = __webpack_require__(138);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),

/***/ 138:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),

/***/ 74:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(71),
	    toString = __webpack_require__(29);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(38);
	
	/**
	 * Converts `string` to
	 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the kebab cased string.
	 * @example
	 *
	 * _.kebabCase('Foo Bar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('fooBar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('__FOO_BAR__');
	 * // => 'foo-bar'
	 */
	var kebabCase = createCompounder(function(result, word, index) {
	  return result + (index ? '-' : '') + word.toLowerCase();
	});
	
	module.exports = kebabCase;


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(38),
	    upperFirst = __webpack_require__(143);
	
	/**
	 * Converts `string` to
	 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.1.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the start cased string.
	 * @example
	 *
	 * _.startCase('--foo-bar--');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('fooBar');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('__FOO_BAR__');
	 * // => 'FOO BAR'
	 */
	var startCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + upperFirst(word);
	});
	
	module.exports = startCase;


/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(135);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(69),
	    hasUnicodeWord = __webpack_require__(73),
	    toString = __webpack_require__(29),
	    unicodeWords = __webpack_require__(74);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(264);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _swipeJsIso = __webpack_require__(178);
	
	var _swipeJsIso2 = _interopRequireDefault(_swipeJsIso);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactSwipe = function (_Component) {
	  _inherits(ReactSwipe, _Component);
	
	  function ReactSwipe() {
	    _classCallCheck(this, ReactSwipe);
	
	    return _possibleConstructorReturn(this, (ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).apply(this, arguments));
	  }
	
	  _createClass(ReactSwipe, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var swipeOptions = this.props.swipeOptions;
	
	
	      this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          childCount = _props.childCount,
	          swipeOptions = _props.swipeOptions;
	
	
	      if (prevProps.childCount !== childCount) {
	        this.swipe.kill();
	        this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.swipe.kill();
	      this.swipe = void 0;
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.swipe.next();
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      this.swipe.prev();
	    }
	  }, {
	    key: 'slide',
	    value: function slide() {
	      var _swipe;
	
	      (_swipe = this.swipe).slide.apply(_swipe, arguments);
	    }
	  }, {
	    key: 'getPos',
	    value: function getPos() {
	      return this.swipe.getPos();
	    }
	  }, {
	    key: 'getNumSlides',
	    value: function getNumSlides() {
	      return this.swipe.getNumSlides();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          style = _props2.style,
	          children = _props2.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(container) {
	            return _this2.container = container;
	          }, id: id, className: 'react-swipe-container ' + className, style: style.container },
	        _react2.default.createElement(
	          'div',
	          { style: style.wrapper },
	          _react2.default.Children.map(children, function (child) {
	            if (!child) {
	              return null;
	            }
	
	            var childStyle = child.props.style ? (0, _objectAssign2.default)({}, style.child, child.props.style) : style.child;
	
	            return _react2.default.cloneElement(child, { style: childStyle });
	          })
	        )
	      );
	    }
	  }]);
	
	  return ReactSwipe;
	}(_react.Component);
	
	ReactSwipe.propTypes = {
	  swipeOptions: _propTypes2.default.shape({
	    startSlide: _propTypes2.default.number,
	    speed: _propTypes2.default.number,
	    auto: _propTypes2.default.number,
	    continuous: _propTypes2.default.bool,
	    disableScroll: _propTypes2.default.bool,
	    stopPropagation: _propTypes2.default.bool,
	    swiping: _propTypes2.default.func,
	    callback: _propTypes2.default.func,
	    transitionEnd: _propTypes2.default.func
	  }),
	  style: _propTypes2.default.shape({
	    container: _propTypes2.default.object,
	    wrapper: _propTypes2.default.object,
	    child: _propTypes2.default.object
	  }),
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  childCount: _propTypes2.default.number
	};
	ReactSwipe.defaultProps = {
	  swipeOptions: {},
	  style: {
	    container: {
	      overflow: 'hidden',
	      visibility: 'hidden',
	      position: 'relative'
	    },
	
	    wrapper: {
	      overflow: 'hidden',
	      position: 'relative'
	    },
	
	    child: {
	      float: 'left',
	      width: '100%',
	      position: 'relative',
	      transitionProperty: 'transform'
	    }
	  },
	  className: '',
	  childCount: 0
	};
	exports.default = ReactSwipe;
	module.exports = exports['default'];


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var styledComponents = __webpack_require__(9);
	
	/**
	 * Converts breakpoint units in px to rem or em
	 * @param {Object} breakpoints - an object containing breakpoint names as keys and the width as value
	 * @param {number} [16] ratio - size of 1 rem in px. What is your main font-size in px? 
	 * @param {'rem' | 'em'} unit
	 */
	function pxToEmOrRem(breakpoints) {
	  var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
	  var unit = arguments[2];
	
	  var newBreakpoints = {};
	
	  for (var key in breakpoints) {
	    var point = breakpoints[key];
	
	    if (String(point).includes('px')) {
	      newBreakpoints[key] = +(parseInt(point) / ratio) + unit;
	      continue;
	    }
	
	    newBreakpoints[key] = point;
	  }
	
	  return newBreakpoints;
	}
	
	/**
	 * Converts breakpoint units in px to em 
	 * @param {Object} breakpoints - an object containing breakpoint names as keys and the width as value
	 * @param {number} [16] ratio - size of 1em in px. What is your main font-size in px? 
	 */
	function pxToEm(breakpoints) {
	  var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
	
	  return pxToEmOrRem(breakpoints, ratio, 'em');
	}
	
	/**
	 * Converts breakpoint units in px to rem 
	 * @param {Object} breakpoints - an object containing breakpoint names as keys and the width as value
	 * @param {number} [16] ratio - size of 1rem in px. What is your main font-size in px? 
	 */
	function pxToRem(breakpoints) {
	  var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
	
	  return pxToEmOrRem(breakpoints, ratio, 'rem');
	}
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    @media (max-width: ', ') {\n      ', '\n    }\n  '], ['\n    @media (max-width: ', ') {\n      ', '\n    }\n  ']);
	var _templateObject2 = _taggedTemplateLiteralLoose(['\n    @media (min-width: ', ') {\n      ', '\n    }\n  '], ['\n    @media (min-width: ', ') {\n      ', '\n    }\n  ']);
	var _templateObject3 = _taggedTemplateLiteralLoose(['\n    @media (min-width: ', ') and\n      (max-width: ', ') {\n      ', '\n    }\n  '], ['\n    @media (min-width: ', ') and\n      (max-width: ', ') {\n      ', '\n    }\n  ']);
	var _templateObject4 = _taggedTemplateLiteralLoose(['\n          @media (max-width: ', ') {\n            ', '\n          }\n        '], ['\n          @media (max-width: ', ') {\n            ', '\n          }\n        ']);
	var _templateObject5 = _taggedTemplateLiteralLoose(['\n          @media (min-width: ', ') {\n            ', '\n          }\n        '], ['\n          @media (min-width: ', ') {\n            ', '\n          }\n        ']);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	/**
	 * Default media breakpoints
	 * @type {Object}
	 */
	var defaultBreakpoints = {
	  huge: '1440px',
	  large: '1170px',
	  medium: '768px',
	  small: '450px'
	};
	
	function getSizeFromBreakpoint(breakpointValue) {
	  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (breakpoints[breakpointValue]) {
	    return breakpoints[breakpointValue];
	  } else if (parseInt(breakpointValue)) {
	    return breakpointValue;
	  } else {
	    console.error('styled-media-query: No valid breakpoint or size specified for media.');
	    return '0';
	  }
	}
	
	/**
	 * Media query generator
	 * @param {Object} breakpoints - Map labels to breakpoint sizes
	 * @return {Object} - Media generators for each breakpoint
	 */
	function generateMedia() {
	  var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultBreakpoints;
	
	  var lessThan = function lessThan(breakpoint) {
	    return function () {
	      return styledComponents.css(_templateObject, getSizeFromBreakpoint(breakpoint, breakpoints), styledComponents.css.apply(undefined, arguments));
	    };
	  };
	
	  var greaterThan = function greaterThan(breakpoint) {
	    return function () {
	      return styledComponents.css(_templateObject2, getSizeFromBreakpoint(breakpoint, breakpoints), styledComponents.css.apply(undefined, arguments));
	    };
	  };
	
	  var between = function between(firstBreakpoint, secondBreakpoint) {
	    return function () {
	      return styledComponents.css(_templateObject3, getSizeFromBreakpoint(firstBreakpoint, breakpoints), getSizeFromBreakpoint(secondBreakpoint, breakpoints), styledComponents.css.apply(undefined, arguments));
	    };
	  };
	
	  var oldStyle = Object.keys(breakpoints).reduce(function (acc, label) {
	    var size = breakpoints[label];
	
	    acc.to[label] = function () {
	      console.warn('styled-media-query: Use media.lessThan(\'' + label + '\') instead of old media.to.' + label + ' (Probably we\'ll deprecate it)');
	      return styledComponents.css(_templateObject4, size, styledComponents.css.apply(undefined, arguments));
	    };
	
	    acc.from[label] = function () {
	      console.warn('styled-media-query: Use media.greaterThan(\'' + label + '\') instead of old media.from.' + label + ' (Probably we\'ll deprecate it)');
	      return styledComponents.css(_templateObject5, size, styledComponents.css.apply(undefined, arguments));
	    };
	
	    return acc;
	  }, { to: {}, from: {} });
	
	  return Object.assign({
	    lessThan: lessThan,
	    greaterThan: greaterThan,
	    between: between
	  }, oldStyle);
	}
	
	/**
	 * Media object with default breakpoints
	 * @return {object} - Media generators for each size
	 */
	var index = generateMedia();
	
	/**
	 * Usage: styled.div` ${media.from.medium`background: #000;`} `;
	 * With this code, background for small and medium sizes will be `default` and for more than medium, will be `#000`
	 */
	
	exports.pxToEm = pxToEm;
	exports.pxToRem = pxToRem;
	exports.defaultBreakpoints = defaultBreakpoints;
	exports.generateMedia = generateMedia;
	exports['default'] = index;
	//# sourceMappingURL=styled-media-query.common.js.map


/***/ }),

/***/ 178:
/***/ (function(module, exports) {

	/*
	 * Swipe 2.0.0
	 * Brad Birdsall
	 * https://github.com/thebird/Swipe
	 * Copyright 2013-2015, MIT License
	 *
	*/
	
	(function (root, factory) {
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = factory();
	    } else {
	        root.Swipe = factory();
	    }
	}(this, function () {
	  'use strict';
	
	  return function Swipe (container, options) {
	    // utilities
	    var noop = function() {}; // simple no operation function
	    var offloadFn = function(fn) { setTimeout(fn || noop, 0); }; // offload a functions execution
	
	    // check browser capabilities
	    var browser = {
	      addEventListener: !!window.addEventListener,
	      touch: ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch,
	      transitions: (function(temp) {
	        var props = ['transitionProperty', 'WebkitTransition', 'MozTransition', 'OTransition', 'msTransition'];
	        for ( var i in props ) if (temp.style[ props[i] ] !== undefined) return true;
	        return false;
	      })(document.createElement('swipe'))
	    };
	
	    // quit if no root element
	    if (!container) return;
	    var element = container.children[0];
	    var slides, slidePos, width, length;
	    options = options || {};
	    var index = parseInt(options.startSlide, 10) || 0;
	    var speed = options.speed || 300;
	    var continuous = options.continuous = options.continuous !== undefined ? options.continuous : true;
	
	    function setup() {
	
	      // cache slides
	      slides = element.children;
	      length = slides.length;
	
	      // set continuous to false if only one slide
	      continuous = slides.length < 2 ? false : options.continuous;
	
	      //special case if two slides
	      if (browser.transitions && continuous && slides.length < 3) {
	        element.appendChild(slides[0].cloneNode(true));
	        element.appendChild(element.children[1].cloneNode(true));
	        slides = element.children;
	      }
	
	      // create an array to store current positions of each slide
	      slidePos = new Array(slides.length);
	
	      // determine width of each slide
	      width = Math.round(container.getBoundingClientRect().width || container.offsetWidth);
	
	      element.style.width = (slides.length * width) + 'px';
	
	      // stack elements
	      var pos = slides.length;
	      while(pos--) {
	
	        var slide = slides[pos];
	
	        slide.style.width = width + 'px';
	        slide.setAttribute('data-index', pos);
	
	        if (browser.transitions) {
	          slide.style.left = (pos * -width) + 'px';
	          move(pos, index > pos ? -width : (index < pos ? width : 0), 0);
	        }
	
	      }
	
	      // reposition elements before and after index
	      if (continuous && browser.transitions) {
	        move(circle(index-1), -width, 0);
	        move(circle(index+1), width, 0);
	      }
	
	      if (!browser.transitions) element.style.left = (index * -width) + 'px';
	
	      container.style.visibility = 'visible';
	
	    }
	
	    function prev() {
	
	      if (continuous) slide(index-1);
	      else if (index) slide(index-1);
	
	    }
	
	    function next() {
	
	      if (continuous) slide(index+1);
	      else if (index < slides.length - 1) slide(index+1);
	
	    }
	
	    function circle(index) {
	
	      // a simple positive modulo using slides.length
	      return (slides.length + (index % slides.length)) % slides.length;
	
	    }
	
	    function slide(to, slideSpeed) {
	
	      // do nothing if already on requested slide
	      if (index == to) return;
	
	      if (browser.transitions) {
	
	        var direction = Math.abs(index-to) / (index-to); // 1: backward, -1: forward
	
	        // get the actual position of the slide
	        if (continuous) {
	          var natural_direction = direction;
	          direction = -slidePos[circle(to)] / width;
	
	          // if going forward but to < index, use to = slides.length + to
	          // if going backward but to > index, use to = -slides.length + to
	          if (direction !== natural_direction) to =  -direction * slides.length + to;
	
	        }
	
	        var diff = Math.abs(index-to) - 1;
	
	        // move all the slides between index and to in the right direction
	        while (diff--) move( circle((to > index ? to : index) - diff - 1), width * direction, 0);
	
	        to = circle(to);
	
	        move(index, width * direction, slideSpeed || speed);
	        move(to, 0, slideSpeed || speed);
	
	        if (continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place
	
	      } else {
	
	        to = circle(to);
	        animate(index * -width, to * -width, slideSpeed || speed);
	        //no fallback for a circular continuous if the browser does not accept transitions
	      }
	
	      index = to;
	      offloadFn(options.callback && options.callback(index, slides[index]));
	    }
	
	    function move(index, dist, speed) {
	
	      translate(index, dist, speed);
	      slidePos[index] = dist;
	
	    }
	
	    function translate(index, dist, speed) {
	
	      var slide = slides[index];
	      var style = slide && slide.style;
	
	      if (!style) return;
	
	      style.webkitTransitionDuration =
	      style.MozTransitionDuration =
	      style.msTransitionDuration =
	      style.OTransitionDuration =
	      style.transitionDuration = speed + 'ms';
	
	      style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
	      style.msTransform =
	      style.MozTransform =
	      style.OTransform = 'translateX(' + dist + 'px)';
	
	    }
	
	    function animate(from, to, speed) {
	
	      // if not an animation, just reposition
	      if (!speed) {
	
	        element.style.left = to + 'px';
	        return;
	
	      }
	
	      var start = +new Date();
	
	      var timer = setInterval(function() {
	
	        var timeElap = +new Date() - start;
	
	        if (timeElap > speed) {
	
	          element.style.left = to + 'px';
	
	          if (delay) begin();
	
	          options.transitionEnd && options.transitionEnd.call(event, index, slides[index]);
	
	          clearInterval(timer);
	          return;
	
	        }
	
	        element.style.left = (( (to - from) * (Math.floor((timeElap / speed) * 100) / 100) ) + from) + 'px';
	
	      }, 4);
	
	    }
	
	    // setup auto slideshow
	    var delay = options.auto || 0;
	    var interval;
	
	    function begin() {
	      clearTimeout(interval);
	      interval = setTimeout(next, delay);
	
	    }
	
	    function stop() {
	
	      delay = 0;
	      clearTimeout(interval);
	
	    }
	
	
	    // setup initial vars
	    var start = {};
	    var delta = {};
	    var isScrolling;
	
	    // setup event capturing
	    var events = {
	
	      handleEvent: function(event) {
	
	        switch (event.type) {
	          case 'touchstart': this.start(event); break;
	          case 'touchmove': this.move(event); break;
	          case 'touchend': offloadFn(this.end(event)); break;
	          case 'webkitTransitionEnd':
	          case 'msTransitionEnd':
	          case 'oTransitionEnd':
	          case 'otransitionend':
	          case 'transitionend': offloadFn(this.transitionEnd(event)); break;
	          case 'resize': offloadFn(setup); break;
	        }
	
	        if (options.stopPropagation) event.stopPropagation();
	
	      },
	      start: function(event) {
	
	        var touches = event.touches[0];
	
	        // measure start values
	        start = {
	
	          // get initial touch coords
	          x: touches.pageX,
	          y: touches.pageY,
	
	          // store time to determine touch duration
	          time: +new Date()
	
	        };
	
	        // used for testing first move event
	        isScrolling = undefined;
	
	        // reset delta and end measurements
	        delta = {};
	
	        // attach touchmove and touchend listeners
	        element.addEventListener('touchmove', this, false);
	        element.addEventListener('touchend', this, false);
	
	      },
	      move: function(event) {
	
	        // ensure swiping with one touch and not pinching
	        if ( event.touches.length > 1 || event.scale && event.scale !== 1) return;
	
	        if (options.disableScroll) return;
	
	        var touches = event.touches[0];
	
	        // measure change in x and y
	        delta = {
	          x: touches.pageX - start.x,
	          y: touches.pageY - start.y
	        };
	
	        // determine if scrolling test has run - one time test
	        if ( typeof isScrolling == 'undefined') {
	          isScrolling = !!( isScrolling || Math.abs(delta.x) < Math.abs(delta.y) );
	        }
	
	        // if user is not trying to scroll vertically
	        if (!isScrolling) {
	
	          // prevent native scrolling
	          event.preventDefault();
	
	          // stop slideshow
	          stop();
	
	          // increase resistance if first or last slide
	          if (continuous) { // we don't add resistance at the end
	
	            translate(circle(index-1), delta.x + slidePos[circle(index-1)], 0);
	            translate(index, delta.x + slidePos[index], 0);
	            translate(circle(index+1), delta.x + slidePos[circle(index+1)], 0);
	
	          } else {
	
	            delta.x =
	              delta.x /
	                ( (!index && delta.x > 0 ||         // if first slide and sliding left
	                  index == slides.length - 1 &&     // or if last slide and sliding right
	                  delta.x < 0                       // and if sliding at all
	                ) ?
	                ( Math.abs(delta.x) / width + 1 )      // determine resistance level
	                : 1 );                                 // no resistance if false
	
	            // translate 1:1
	            translate(index-1, delta.x + slidePos[index-1], 0);
	            translate(index, delta.x + slidePos[index], 0);
	            translate(index+1, delta.x + slidePos[index+1], 0);
	          }
	          options.swiping && options.swiping(-delta.x / width);
	
	        }
	
	      },
	      end: function(event) {
	
	        // measure duration
	        var duration = +new Date() - start.time;
	
	        // determine if slide attempt triggers next/prev slide
	        var isValidSlide =
	              Number(duration) < 250 &&         // if slide duration is less than 250ms
	              Math.abs(delta.x) > 20 ||         // and if slide amt is greater than 20px
	              Math.abs(delta.x) > width/2;      // or if slide amt is greater than half the width
	
	        // determine if slide attempt is past start and end
	        var isPastBounds =
	              !index && delta.x > 0 ||                      // if first slide and slide amt is greater than 0
	              index == slides.length - 1 && delta.x < 0;    // or if last slide and slide amt is less than 0
	
	        if (continuous) isPastBounds = false;
	
	        // determine direction of swipe (true:right, false:left)
	        var direction = delta.x < 0;
	
	        // if not scrolling vertically
	        if (!isScrolling) {
	
	          if (isValidSlide && !isPastBounds) {
	
	            if (direction) {
	
	              if (continuous) { // we need to get the next in this direction in place
	
	                move(circle(index-1), -width, 0);
	                move(circle(index+2), width, 0);
	
	              } else {
	                move(index-1, -width, 0);
	              }
	
	              move(index, slidePos[index]-width, speed);
	              move(circle(index+1), slidePos[circle(index+1)]-width, speed);
	              index = circle(index+1);
	
	            } else {
	              if (continuous) { // we need to get the next in this direction in place
	
	                move(circle(index+1), width, 0);
	                move(circle(index-2), -width, 0);
	
	              } else {
	                move(index+1, width, 0);
	              }
	
	              move(index, slidePos[index]+width, speed);
	              move(circle(index-1), slidePos[circle(index-1)]+width, speed);
	              index = circle(index-1);
	
	            }
	
	            options.callback && options.callback(index, slides[index]);
	
	          } else {
	
	            if (continuous) {
	
	              move(circle(index-1), -width, speed);
	              move(index, 0, speed);
	              move(circle(index+1), width, speed);
	
	            } else {
	
	              move(index-1, -width, speed);
	              move(index, 0, speed);
	              move(index+1, width, speed);
	            }
	
	          }
	
	        }
	
	        // kill touchmove and touchend event listeners until touchstart called again
	        element.removeEventListener('touchmove', events, false);
	        element.removeEventListener('touchend', events, false);
	        element.removeEventListener('touchforcechange', function() {}, false);
	
	      },
	      transitionEnd: function(event) {
	
	        if (parseInt(event.target.getAttribute('data-index'), 10) == index) {
	
	          if (delay) begin();
	
	          options.transitionEnd && options.transitionEnd.call(event, index, slides[index]);
	
	        }
	
	      }
	
	    };
	
	    // trigger setup
	    setup();
	
	    // start auto slideshow if applicable
	    if (delay) begin();
	
	
	    // add event listeners
	    if (browser.addEventListener) {
	
	      // set touchstart event on element
	      if (browser.touch) {
	        element.addEventListener('touchstart', events, false);
	        element.addEventListener('touchforcechange', function() {}, false);
	      }
	
	      if (browser.transitions) {
	        element.addEventListener('webkitTransitionEnd', events, false);
	        element.addEventListener('msTransitionEnd', events, false);
	        element.addEventListener('oTransitionEnd', events, false);
	        element.addEventListener('otransitionend', events, false);
	        element.addEventListener('transitionend', events, false);
	      }
	
	      // set resize event on window
	      window.addEventListener('resize', events, false);
	
	    } else {
	
	      window.onresize = function () { setup(); }; // to play nice with old IE
	
	    }
	
	    // expose the Swipe API
	    return {
	      setup: function() {
	
	        setup();
	
	      },
	      slide: function(to, speed) {
	
	        // cancel slideshow
	        stop();
	
	        slide(to, speed);
	
	      },
	      prev: function() {
	
	        // cancel slideshow
	        stop();
	
	        prev();
	
	      },
	      next: function() {
	
	        // cancel slideshow
	        stop();
	
	        next();
	
	      },
	      stop: function() {
	
	        // cancel slideshow
	        stop();
	
	      },
	      getPos: function() {
	
	        // return current index position
	        return index;
	
	      },
	      getNumSlides: function() {
	
	        // return total number of slides
	        return length;
	      },
	      kill: function() {
	
	        // cancel slideshow
	        stop();
	
	        // reset element
	        element.style.width = '';
	        element.style.left = '';
	
	        // reset slides
	        var pos = slides.length;
	        while(pos--) {
	
	          var slide = slides[pos];
	          slide.style.width = '';
	          slide.style.left = '';
	
	          if (browser.transitions) translate(pos, 0, 0);
	        }
	
	        // removed event listeners
	        if (browser.addEventListener) {
	
	          // remove current event listeners
	          element.removeEventListener('touchstart', events, false);
	          element.removeEventListener('webkitTransitionEnd', events, false);
	          element.removeEventListener('msTransitionEnd', events, false);
	          element.removeEventListener('oTransitionEnd', events, false);
	          element.removeEventListener('otransitionend', events, false);
	          element.removeEventListener('transitionend', events, false);
	          window.removeEventListener('resize', events, false);
	
	        } else {
	          window.onresize = null;
	        }
	      }
	    };
	  };
	}));


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: 9vw;\n  z-index: 1;\n\n  .react-swipe-container {\n    height: 100%;\n    // max-width: 800px;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    > div, a {\n      height: 100%;\n      cursor: url(/i/zoom.png), pointer;\n\n      .gatsby-image-outer-wrapper,\n      .gatsby-image-wrapper {\n        position: relative;\n        height: 100%\n      }\n    }\n  }\n'], ['\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: 9vw;\n  z-index: 1;\n\n  .react-swipe-container {\n    height: 100%;\n    // max-width: 800px;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    > div, a {\n      height: 100%;\n      cursor: url(/i/zoom.png), pointer;\n\n      .gatsby-image-outer-wrapper,\n      .gatsby-image-wrapper {\n        position: relative;\n        height: 100%\n      }\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: 15%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  p {\n    visibility: hidden;\n  }\n'], ['\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: 15%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  p {\n    visibility: hidden;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  left: 0;\n  cursor: url(/i/prev.png), e-resize;\n\n'], ['\n  left: 0;\n  cursor: url(/i/prev.png), e-resize;\n\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  right: 0;\n  cursor: url(/i/next.png), w-resize;\n'], ['\n  right: 0;\n  cursor: url(/i/next.png), w-resize;\n']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledMediaQuery = __webpack_require__(45);
	
	var _styledMediaQuery2 = _interopRequireDefault(_styledMediaQuery);
	
	var _reactSwipe = __webpack_require__(170);
	
	var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(67);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Components
	
	
	var SliderContainer = _styledComponents2.default.div(_templateObject);
	
	var Arrow = _styledComponents2.default.div(_templateObject2);
	
	var ArrowPrev = (0, _styledComponents2.default)(Arrow)(_templateObject3);
	var ArrowNext = (0, _styledComponents2.default)(Arrow)(_templateObject4);
	
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      current: 0
	    };
	    return _this;
	  }
	
	  Slider.prototype.prev = function prev() {
	    this.reactSwipe.prev();
	  };
	
	  Slider.prototype.next = function next() {
	    this.reactSwipe.next();
	  };
	
	  Slider.prototype.handleSlideChange = function handleSlideChange(index) {
	    this.props.onChange(index);
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var current = this.props.current;
	
	    this.setState({
	      current: current
	    });
	  };
	
	  Slider.prototype.componentDidMount = function componentDidMount() {
	    var current = this.props.current;
	
	    if (current >= this.reactSwipe.getNumSlides()) {
	      this.reactSwipe.slide(0, 0);
	    }
	  };
	
	  Slider.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      SliderContainer,
	      null,
	      _react2.default.createElement(
	        _reactSwipe2.default,
	        {
	          ref: function ref(reactSwipe) {
	            return _this2.reactSwipe = reactSwipe;
	          },
	          swipeOptions: {
	            callback: this.handleSlideChange.bind(this),
	            startSlide: this.state.current
	          } },
	        this.props.data.map(function (_ref) {
	          var node = _ref.node;
	          var _node$frontmatter = node.frontmatter,
	              path = _node$frontmatter.path,
	              title = _node$frontmatter.title,
	              cover = _node$frontmatter.cover;
	          var slug = node.fields.slug;
	
	
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            { key: slug, to: slug },
	            _react2.default.createElement(_gatsbyImage2.default, {
	              title: title,
	              sizes: cover.childImageSharp.sizes })
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          ArrowPrev,
	          { onClick: this.prev.bind(this) },
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u2190'
	          )
	        ),
	        _react2.default.createElement(
	          ArrowNext,
	          { onClick: this.next.bind(this) },
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u2192'
	          )
	        )
	      )
	    );
	  };
	
	  return Slider;
	}(_react.Component);
	
	exports.default = Slider;
	module.exports = exports['default'];

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _kebabCase = __webpack_require__(76);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _startCase = __webpack_require__(142);
	
	var _startCase2 = _interopRequireDefault(_startCase);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(67);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Slider = __webpack_require__(113);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Nav = __webpack_require__(33);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Utilities
	
	
	// Components
	
	
	var DisciplineContainer = _styledComponents2.default.div(_templateObject);
	
	var Discipline = function (_Component) {
	  _inherits(Discipline, _Component);
	
	  function Discipline(props) {
	    _classCallCheck(this, Discipline);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      current: 1
	    };
	    return _this;
	  }
	
	  Discipline.prototype.setURL = function setURL(current) {
	    var pathname = this.props.location.pathname;
	
	    var url = pathname + '?slide=' + current;
	
	    this.setState({ current: current });
	    (0, _gatsbyLink.navigateTo)(url);
	  };
	
	  Discipline.prototype.componentWillMount = function componentWillMount() {
	    var _props$location = this.props.location,
	        pathname = _props$location.pathname,
	        search = _props$location.search;
	
	    var getParam = /(\d+)(?!.*\d)/;
	
	    var current = search !== '' ? Number(search.match(getParam)[0]) : 0;
	    this.setState({ current: current });
	  };
	
	  Discipline.prototype.componentDidMount = function componentDidMount() {
	    console.clear();
	  };
	
	  Discipline.prototype.render = function render() {
	    var _props$pathContext = this.props.pathContext,
	        discipline = _props$pathContext.discipline,
	        disciplines = _props$pathContext.disciplines;
	    var _props$data$allMarkdo = this.props.data.allMarkdownRemark,
	        edges = _props$data$allMarkdo.edges,
	        totalCount = _props$data$allMarkdo.totalCount;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: '' + (0, _startCase2.default)(discipline) }),
	      _react2.default.createElement(
	        DisciplineContainer,
	        null,
	        _react2.default.createElement(_Slider2.default, {
	          data: edges,
	          current: this.state.current,
	          onChange: this.setURL.bind(this)
	        })
	      ),
	      _react2.default.createElement(
	        _Nav2.default,
	        null,
	        disciplines.map(function (discipline) {
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              key: discipline,
	              activeClassName: 'active',
	              to: '/discipline/' + (0, _kebabCase2.default)(discipline) + '/'
	            },
	            discipline
	          );
	        })
	      )
	    );
	  };
	
	  return Discipline;
	}(_react.Component);
	
	Discipline.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    discipline: _propTypes2.default.string.isRequired
	  }),
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      totalCount: _propTypes2.default.number.isRequired,
	      edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        node: _propTypes2.default.shape({
	          frontmatter: _propTypes2.default.shape({
	            title: _propTypes2.default.string.isRequired,
	            cover: _propTypes2.default.object.isRequired
	          })
	        })
	      }).isRequired)
	    })
	  })
	};
	
	exports.default = Discipline;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-discipline-js-a82ed1defab80b97ea44.js